import { PureComponent } from 'react';
import { connect } from 'react-redux';

import clone from 'lodash/clone';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import values from 'lodash/values';
import PropTypes from 'prop-types';

import i18n from 'shared/lib/i18n';

import DocumentLibraryComponent from '../components/DocumentLibraryComponent';

import { SET_MODAL_TYPE } from '../../../actionConstants';
import {
  getBuilding,
  getBuildingsForFilter,
} from '../../Building/actionCreators';
import {
  checkDocument,
  clearDocumentLibrary,
  createFolder,
  getAdminRootDirectories,
  getDirectoriesById,
  getDirectoryDataById,
  getNumberOfChildren,
  getRootDirectories,
  globalSearch,
  onDelete,
} from '../actions';

import { getTodayCount, isAdmin } from '../../../utils';
import { getRoleIdByName } from '../../Person/utils';
import { getAllPropertiesSelectValue, insertBackButton } from '../utils';

import { roleNames } from '../../Person/constants';
import { CREATE_FOLDER_FORM, LIST_KEY, UPLOAD_FILE_FORM } from '../constants';

import { CONFIRM } from '../../Modal/modalTypes';

class DocumentLibraryContainer extends PureComponent {
  static getDerivedStateFromProps(props, state) {
    const preselectedPropertyId = Number(
      get(props.match, 'params.buildingId', null) ||
        get(props.match, 'params.PMCId', null),
    );
    const currentBuilding = get(state, 'selectedValue.value', null);
    if (preselectedPropertyId && preselectedPropertyId !== currentBuilding) {
      return {
        selectedValue: { value: preselectedPropertyId },
        hasPreselected: true,
      };
    }
    if (props.directoryDataForEdit !== state.directoryDataForEdit) {
      return { directoryDataForEdit: props.directoryDataForEdit };
    }
    if (props.shouldClearBreadcrumbs) {
      return { breadcrumbs: [] };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.getSelectOptions = this.getSelectOptions.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.showModalImg = this.showModalImg.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.showModalFolder = this.showModalFolder.bind(this);
    this.createNewFolder = this.createNewFolder.bind(this);
    this.showModalFile = this.showModalFile.bind(this);
    this.uploadNewFile = this.uploadNewFile.bind(this);
    this.onDeleteItem = this.onDeleteItem.bind(this);
    this.prepareDataForEditAction = this.prepareDataForEditAction.bind(this);
    this.setInitialValues = this.setInitialValues.bind(this);
    this.deleteFolder = this.deleteFolder.bind(this);
    this.deleteDocument = this.deleteDocument.bind(this);
    this.getItems = this.getItems.bind(this);

    this.state = {
      selectOptions: [],
      breadcrumbs: [],
      selectedValue: getAllPropertiesSelectValue(),
      inputValue: '',
      showModal: false,
      isModalViewImg: false,
      isModalFolder: false,
      isModalFile: false,
      folderID: null,
      fileUrl: null,
      fileName: null,
      fileType: null,
      timeout: null,
      isSearching: false,
      isEditAction: false,
      initialValues: {},
      directoryDataForEdit: {},
      hasPreselected: false,
    };
  }

  componentDidMount() {
    const { attachDocument } = this.props;
    if (attachDocument) {
      this.getItems();
    }
  }

  componentDidUpdate() {
    const { selectOptions, hasPreselected } = this.state;
    const { buildings, getAdminRootDirectories } = this.props;
    if (isEmpty(selectOptions) && !isEmpty(buildings) && !hasPreselected) {
      if (isAdmin()) {
        getAdminRootDirectories();
        return this.getSelectOptions();
      }
      return this.getSelectOptions();
    }
    return null;
  }

  componentWillUnmount() {
    const { clear } = this.props;
    clear();
  }

  handleClick(e) {
    const { id, name } = e.target;
    const { breadcrumbs, isSearching, inputValue } = this.state;
    const { listParams, directories, defaultParams } = this.props;

    const pressedItem = document.getElementById(id);
    const type = pressedItem.getAttribute('data-type');
    const url = pressedItem.getAttribute('data-url');
    const searchBreadcrumbs = [];
    if (isSearching && type === 'directory') {
      const chosenFolder = find(
        directories.results,
        (folder) => folder.id === Number(id),
      );
      forEach(get(chosenFolder, 'breadcrumbs', []), (breadcrumb) =>
        searchBreadcrumbs.push(breadcrumb),
      );
    }
    this.setState(
      {
        breadcrumbs: isSearching ? searchBreadcrumbs : breadcrumbs,
        isSearching:
          type === 'directory' || type === 'backButton' ? false : isSearching,
        inputValue:
          type === 'directory' || type === 'backButton' ? '' : inputValue,
      },
      () => {
        const { getRootDirectories, getDirectoriesById, attachDocument } =
          this.props;
        const { breadcrumbs: stateBreadcrumbs } = this.state;
        const breadcrumbs = clone(stateBreadcrumbs);
        if (id === 'root') {
          getRootDirectories(listParams).then(() => {
            this.setState({
              selectedValue: getAllPropertiesSelectValue(),
              breadcrumbs: [],
              folderID: null,
            });
          });
        } else if (type === 'directory' || type === 'backButton') {
          getDirectoriesById(Number(id), defaultParams).then(() => {
            type === 'directory'
              ? breadcrumbs.push({
                  id: Number(id),
                  name,
                })
              : breadcrumbs.pop();
            this.setState({ breadcrumbs, folderID: Number(id) });
          });
        } else if (attachDocument) {
          attachDocument(id, name);
        } else {
          this.showModalImg(url, name, type);
        }
      },
    );
  }

  onSelectChange(event, selectedValue) {
    const {
      listParams,
      getRootDirectories,
      getDirectoriesById,
      adminRootDirectories,
      currentUser,
    } = this.props;
    if (!selectedValue || selectedValue.value === 'all_properties') {
      this.setState(
        {
          selectedValue: getAllPropertiesSelectValue(),
          breadcrumbs: [],
          inputValue: '',
          isSearching: false,
        },
        () => getRootDirectories(listParams),
      );
    } else {
      this.setState({ selectedValue, inputValue: '', isSearching: false });
      if (isAdmin()) {
        const selectProperty = find(
          adminRootDirectories,
          (property) => property.building === selectedValue.value,
        );
        const rootDir = get(selectProperty, 'directory', null);
        rootDir &&
          getDirectoriesById(rootDir, listParams).then(() => {
            this.setState({ breadcrumbs: [] });
          });
      } else {
        const userProperties = get(currentUser, 'properties', []);
        const selectProperty =
          userProperties.length > 0 &&
          find(
            userProperties,
            (property) => property.id === selectedValue.value,
          );
        const rootDir = get(selectProperty, 'rootDirectory', null);
        rootDir &&
          getDirectoriesById(rootDir, listParams).then(() => {
            this.setState({ breadcrumbs: [] });
          });
      }
    }
  }

  onSearchChange(e) {
    let { timeout, folderID } = this.state;
    const { value } = e.target;
    const { listParams, globalSearch, getRootDirectories, getDirectoriesById } =
      this.props;
    this.setState({
      isSearching: true,
      inputValue: value,
    });

    e.target.onkeyup = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        value !== '' &&
          globalSearch({
            ...listParams,
            q: value,
          });
      }, 500);
      this.setState({ timeout });
    };

    if (value === '' && folderID === null) {
      this.setState({ isSearching: false, breadcrumbs: [] }, () =>
        getRootDirectories(listParams),
      );
    } else if (value === '' && folderID !== null) {
      this.setState({ isSearching: false }, () =>
        getDirectoriesById(folderID, listParams),
      );
    }
  }

  onDeleteItem(item) {
    const { getNumberOfChildren } = this.props;
    item.type === 'directory'
      ? getNumberOfChildren(item.id).then(() => this.deleteFolder(item))
      : this.deleteDocument(item);
  }

  getSelectOptions() {
    let selectOptions = [getAllPropertiesSelectValue()];
    const { buildings } = this.props;
    if (!isEmpty(buildings)) {
      buildings.map((property) => {
        selectOptions = [
          ...selectOptions,
          { value: property.id, label: property.name },
        ];
        return false;
      });
    }
    this.setState({ selectOptions });
  }

  async getItems(params) {
    const { hasPreselected, folderID, inputValue } = this.state;
    const {
      getDirectoriesById,
      currentUser,
      match,
      getRootDirectories,
      pmcId,
      globalSearch,
      directoryData,
      getAdminRootDirectories,
    } = this.props;

    const listParams = params;

    if (folderID) {
      return getDirectoriesById(folderID, listParams);
    }
    const propertyId = Number(
      get(match, 'params.buildingId', null) || get(match, 'params.PMCId', null),
    );

    if (hasPreselected && isAdmin() && !pmcId) {
      const adminRootDirectories = await getAdminRootDirectories();
      const selectProperty = find(
        adminRootDirectories,
        (property) => property.building === propertyId,
      );
      const rootDir = get(selectProperty, 'directory', null);
      return rootDir && getDirectoriesById(rootDir, listParams);
    }

    if (hasPreselected && isAdmin() && pmcId) {
      const rootDirectories = await getRootDirectories();
      const rootDir = get(rootDirectories, '[0].id', null);
      return rootDir && getDirectoriesById(rootDir, listParams);
    }

    if (hasPreselected && !isAdmin() && !pmcId) {
      const userProperties = get(currentUser, 'properties', []);
      const selectProperty =
        userProperties.length > 0 &&
        find(userProperties, (property) => property.id === propertyId);
      const rootDir = get(selectProperty, 'rootDirectory', null);
      return rootDir && getDirectoriesById(rootDir);
    }
    const { isSearching } = this.state;
    const buildingId = Number(get(match, 'params.buildingId', null));
    if (buildingId) {
      listParams.building = buildingId;
    }
    const searchInput = inputValue ?? '';
    if (isEmpty(directoryData)) {
      return isSearching
        ? globalSearch({ ...listParams, q: searchInput })
        : getRootDirectories(listParams);
    }
    return getRootDirectories(listParams);
  }

  setInitialValues() {
    const { directoryDataForEdit } = this.state;
    this.setState({
      initialValues: {
        id: directoryDataForEdit.id,
        name: directoryDataForEdit.name,
        super: directoryDataForEdit.allowedRoles.includes(
          getRoleIdByName(roleNames.superintendent),
        ),
        owner: directoryDataForEdit.allowedRoles.includes(
          getRoleIdByName(roleNames.owner),
        ),
        handyman: directoryDataForEdit.allowedRoles.includes(
          getRoleIdByName(roleNames.handyman),
        ),
        tenant: directoryDataForEdit.allowedRoles.includes(
          getRoleIdByName(roleNames.tenant),
        ),
        boardMember: directoryDataForEdit.allowedRoles.includes(
          getRoleIdByName(roleNames.board_member),
        ),
        concierge: directoryDataForEdit.allowedRoles.includes(
          getRoleIdByName(roleNames.concierge),
        ),
        broker: directoryDataForEdit.allowedRoles.includes(
          getRoleIdByName(roleNames.broker),
        ),
      },
    });
  }

  prepareDataForEditAction(id) {
    const { getDirectoryDataForEdit } = this.props;
    getDirectoryDataForEdit(id, true).then(() => this.setInitialValues());
  }

  deleteFolder(item) {
    const { onDelete, directoryData, numberOfChildren, listParams } =
      this.props;
    const parentId = get(directoryData, 'id', null);
    const numberOfDocs = get(numberOfChildren, 'childDocuments', null);
    numberOfDocs !== null &&
      onDelete(
        item.id,
        parentId,
        item.type,
        item.name,
        numberOfDocs,
        listParams,
      );
  }

  deleteDocument(item) {
    const { onDelete, directoryData, listParams } = this.props;
    const parentId = get(directoryData, 'id', null);
    onDelete(item.id, parentId, item.type, item.name, null, listParams);
  }

  closeModal() {
    this.setState({
      showModal: false,
      isModalViewImg: false,
      isModalFolder: false,
      isModalFile: false,
      fileUrl: null,
      fileName: null,
      fileType: null,
      isEditAction: false,
      initialValues: {},
    });
  }

  showModalImg(url, name, type) {
    this.setState({
      showModal: true,
      isModalViewImg: true,
      fileUrl: url,
      fileName: name,
      fileType: type,
      isModalFolder: false,
      isModalFile: false,
    });
  }

  showModalFolder(id, isEditAction = false) {
    this.setState(
      {
        showModal: true,
        isModalFolder: true,
        isModalFile: false,
        isModalViewImg: false,
        isEditAction: !!isEditAction,
        folderID: id,
      },
      () => {
        const { isEditAction } = this.state;
        if (isEditAction) {
          this.prepareDataForEditAction(id);
        }
      },
    );
  }

  showModalFile(id) {
    this.setState({
      showModal: true,
      isModalFolder: false,
      isModalFile: true,
      isModalViewImg: false,
      folderID: id,
    });
  }

  createNewFolder(data) {
    const { createFolder, directoryData, listParams } = this.props;
    const { folderID, isEditAction } = this.state;
    const allowedRoles = [
      getRoleIdByName(roleNames.property_manager),
      getRoleIdByName(roleNames.pmc_owner),
    ];
    const parentId = get(directoryData, 'id', null);
    data.super && allowedRoles.push(getRoleIdByName(roleNames.superintendent));
    data.handyman && allowedRoles.push(getRoleIdByName(roleNames.handyman));
    data.owner && allowedRoles.push(getRoleIdByName(roleNames.owner));
    data.tenant && allowedRoles.push(getRoleIdByName(roleNames.tenant));
    data.concierge && allowedRoles.push(getRoleIdByName(roleNames.concierge));
    data.broker && allowedRoles.push(getRoleIdByName(roleNames.broker));
    data.boardMember &&
      allowedRoles.push(getRoleIdByName(roleNames.board_member));

    const formattedData = {
      name: data.name,
      allowed_roles: allowedRoles,
    };
    createFolder(formattedData, folderID, isEditAction, parentId, listParams);
    this.closeModal();
  }

  uploadNewFile(data) {
    const { directoryData, checkDocument } = this.props;
    if (!data.file) {
      return false;
    }

    const formData = new FormData();
    forEach(data.file, (file) => formData.append('document', file));
    forEach(data.file, (file) =>
      checkDocument(directoryData.id, { name: file.name }, formData),
    );
    this.closeModal();
    return null;
  }

  render() {
    const {
      inputValue,
      selectedValue,
      selectOptions,
      fileUrl,
      fileName,
      fileType,
      showModal,
      breadcrumbs,
      isModalViewImg,
      isModalFolder,
      isModalFile,
      isSearching,
      initialValues,
      isEditAction,
      hasPreselected,
    } = this.state;
    const {
      listParams,
      getRootDirectories,
      directoryData,
      directories,
      isLoading,
      onLoad,
      listKey,
      currentUser,
      match,
      pmcId,
    } = this.props;
    const props = {
      inputValue,
      selectedValue,
      selectOptions,
      isLoading,
      fileUrl,
      fileName,
      fileType,
      onLoad,
      listKey,
      isSearching,
      user: currentUser,
      breadcrumbs,
      isModalViewImg,
      isModalFolder,
      isModalFile,
      isEditAction,
      initialValues,
      hasPreselected,
      pmcId,
      form: isModalFolder ? CREATE_FOLDER_FORM : UPLOAD_FILE_FORM,
      onSubmit: isModalFolder ? this.createNewFolder : this.uploadNewFile,
      isModalShown: showModal,
      onSelectChange: this.onSelectChange,
      onSearchChange: this.onSearchChange,
      onDeleteItem: this.onDeleteItem,
      handleClick: this.handleClick,
      closeModal: this.closeModal,
      showModalFolder: this.showModalFolder,
      showModalFile: this.showModalFile,
      items: isSearching
        ? directories
        : insertBackButton(directories, directoryData),
      listParams,
      directoryData,
      getItems: (listParams) => {
        this.getItems(listParams);
      },
      getRootDirectories,
      preselectedBuilding: get(match, 'params.buildingId', null),
    };
    return <DocumentLibraryComponent {...props} />;
  }
}

DocumentLibraryContainer.propTypes = {
  pmcId: PropTypes.number,
  numberOfChildren: PropTypes.instanceOf(Object),
  match: PropTypes.instanceOf(Object),
  currentUser: PropTypes.instanceOf(Object),
  directories: PropTypes.instanceOf(Object),
  directoryData: PropTypes.instanceOf(Object),
  directoryDataForEdit: PropTypes.instanceOf(Object),
  listParams: PropTypes.instanceOf(Object),
  adminRootDirectories: PropTypes.instanceOf(Array),
  buildings: PropTypes.instanceOf(Array),
  shouldClearBreadcrumbs: PropTypes.bool,
  isLoading: PropTypes.bool,
  listKey: PropTypes.string,
  onLoad: PropTypes.func.isRequired,
  getBuildingById: PropTypes.func.isRequired,
  getAdminRootDirectories: PropTypes.func.isRequired,
  getRootDirectories: PropTypes.func.isRequired,
  getDirectoriesById: PropTypes.func.isRequired,
  getDirectoryDataForEdit: PropTypes.func.isRequired,
  createFolder: PropTypes.func.isRequired,
  globalSearch: PropTypes.func.isRequired,
  getNumberOfChildren: PropTypes.func.isRequired,
  checkDocument: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  attachDocument: PropTypes.func,
  defaultParams: PropTypes.instanceOf(Object),
};

const mapStateToProps = (state, ownProps) => {
  const { buildings, documentLibrary, common } = state;
  const { match } = ownProps;
  const pmcId = Number(get(match, 'params.PMCId', null));

  const defaultParams = {
    limit: 25,
    offset: 0,
  };

  return {
    currentUser: get(common, 'currentUser', {}),
    directories: get(documentLibrary, 'directories', {}),
    directoryData: get(documentLibrary, 'directoryData', {}),
    numberOfChildren: get(documentLibrary, 'numberOfChildren', null),
    shouldClearBreadcrumbs: get(
      documentLibrary,
      'shouldClearBreadcrumbs',
      false,
    ),
    adminRootDirectories: get(documentLibrary, 'adminRootDirectories', []),
    directoryDataForEdit: get(documentLibrary, 'directoryDataForEdit', {}),
    buildings: values(buildings),
    listKey: LIST_KEY,
    listParams: get(state, `lists.${LIST_KEY}`, {}),
    isLoading: !!common.loading.length,
    pmcId,
    defaultParams,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { match } = ownProps;
  const pmcId = Number(get(match, 'params.PMCId', null));
  return {
    onLoad: (params) => getBuildingsForFilter(dispatch, params),
    getBuildingById: (buildingId) => getBuilding(dispatch, buildingId),
    getAdminRootDirectories: () => getAdminRootDirectories(dispatch),
    getRootDirectories: (queryParams) => {
      const params = { ...queryParams };
      if (pmcId) {
        params.pmc = pmcId;
      }
      getTodayCount(getRootDirectories, dispatch, params);
      return getRootDirectories(dispatch, params);
    },
    getDirectoriesById: (dirID, queryParams) => {
      getTodayCount(getDirectoriesById, dispatch, queryParams, dirID, false);
      return getDirectoriesById(dispatch, queryParams, dirID);
    },
    getDirectoryDataForEdit: (dirID, isForEditInfo) =>
      getDirectoryDataById(dispatch, dirID, isForEditInfo),
    createFolder: (data, dirID, isEditAction, parentId, queryParams) =>
      createFolder(dispatch, data, dirID, isEditAction, parentId, queryParams),
    // uploadFile: (data, dirID) => uploadFile(dispatch, data, dirID),
    globalSearch: (queryParams) => {
      const params = { ...queryParams };
      if (pmcId) {
        params.pmc = pmcId;
      }
      return globalSearch(dispatch, params);
    },
    getNumberOfChildren: (id) => getNumberOfChildren(dispatch, id),
    checkDocument: (id, data, formData) =>
      checkDocument(dispatch, id, data, formData),
    onDelete: (itemId, id, typeOfItem, itemName, numberOfDocs, queryParams) => {
      const modalProps = {
        bodyText:
          numberOfDocs > 0
            ? i18n.t('documentLibrary.removeNoteNotEmpty', {
                numberOfDocs,
                itemName,
              })
            : i18n.t('documentLibrary.removeNote', { itemName }),
        onConfirm: () =>
          onDelete(dispatch, itemId, id, typeOfItem, queryParams),
      };
      dispatch({
        type: SET_MODAL_TYPE,
        modalType: CONFIRM,
        modalProps,
      });
    },
    clear: () => clearDocumentLibrary(dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentLibraryContainer);
